<p-dialog 
    [(visible)]="visible" 
    (onHide)="onCloseDialog()"
    [modal]="true" 
    class="p-fluid responsive-dialog-usuario" 
    header="Cambiar Titular" 
    [draggable]="false"
    [style]="{ 'max-width': '300px', 'width': '100%' }"
>
    <ng-template pTemplate="content">
        <label>Selecciona un titular</label>
        <p-dropdown 
            [options]="titulares" 
            optionLabel="nombreCompleto"
            optionValue="uniqueId"
            [filter]="true"
            filterBy="nombreCompleto"
            placeholder="Selecciona un titular"
            appendTo="body"
            [ngModel]="titularPreSeleccionado"
            (ngModelChange)="onTitularChange($event)"
        >
        </p-dropdown>
    </ng-template>

    <ng-template pTemplate="footer">
        <button 
            pButton 
            pRipple 
            label="Cancelar" 
            icon="pi pi-times" 
            class="p-button-text"
            (click)="onCloseDialog()"
        ></button>
        
        <button 
            pButton 
            pRipple 
            type="submit"
            icon="pi pi-check" 
            class="p-button-text" 
            label="Guardar Cambios"
            (click)="onConfirmSubmitDialog()" 
            [disabled]="disabled()">
        </button>
    </ng-template>
</p-dialog>
